<template>
    <div>
        <div class="header">
            Hoe werkt dit?
        </div>
        <p>Met deze tool kun je een pushbericht sturen naar duizenden browsers en mobiele apparaten van gebruikers die hiervoor toestemming hebben gegeven.</p>

        <p>Pushberichten zijn altijd gebasseerd op een artikel en gebruikt in de eerste instantie de infomatie uit het bijbehordende item (zoals de headline, image etc). De titel en body van het bericht kunnen zo nodig aangepast worden.</p>

        <h3>Stap 1:</h3>
        <p>Kies een artikel op nrc.nl, kopieer de volledige url en plak deze in het formulier. Het bijbehordende item zal nu worden opgehaald en het formulier wordt verder ingevuld.</p>

        <h3>Stap 2:</h3>
        <p>Pas zo nodig de titel en de tekst aan.</p>

        <h3>Stap 3:</h3>
        <p>Kies het kanaal waar dit bericht naar toe gezonden moet worden: 
            <ul>
                <li> Gebruik <strong>Nieuws</strong> bij "Breaking News", oorlog e.d.</li>
                <li> Gebruik <strong>Het Beste van NRC</strong> om <span class="red">maximaal 2 keer per dag</span> een redactionele selectie te versturen.</li>
            </ul>
        </p>

        <h3>Stap 4:</h3>
        <p>Klik op <strong>Verstuur bericht</strong> en daarna op de bevestiging. Voila.</p>

        <img src="https://media.giphy.com/media/MCZ39lz83o5lC/giphy.gif">
        <button @click="close">OK, aan de slag</button>
    </div>
</template>

<script>
    export default {
        methods: {
            close: function() {
                this.$emit("hideinfo")
            },
        }
    };
</script>

<style scoped>
    li {
        line-height: 24px;
    }
    .red {
        color: red;
    }
    button {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        margin-top: 24px;
        display: inline-block;
        background-color: #007bff;
        color: white;
        padding: 9px 17px;
        /*font-size: 24px;*/
        border: 1px solid #007bff;
        border-radius: 4px;
        cursor: pointer;
    }
</style>